"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getReverseNumberParts = function getReverseNumberParts(number) {
  var parts = [];
  var int = Math.trunc(number);
  while (int > 0) {
    parts.push(int % 1000);
    int = Math.floor(int / 1000);
  }

  return parts;
};

exports.default = getReverseNumberParts;